/**
 * Formats a UTC ISO timestamp in the viewer's local timezone, e.g. "Oct 14, 2026 - 3:06 AM GMT+8".
 * NOTE: serialised with .toString() into the dashboard HTML (template.ts §11 WIP badge).
 * Must remain self-contained: reference only globals (Date, Intl, Number), no imports/helpers.
 * The renderWipTimestamp vm test in template.test.ts catches a regression, since it only exposes Date/Intl/Number.
 */
export function formatLocalTimestamp(
  isoTimestamp: string,
  timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone,
): string {
  const date = new Date(isoTimestamp)

  if (Number.isNaN(date.getTime())) {
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
  }

  const dateText = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone,
  }).format(date)
  const timeText = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'short',
    timeZone,
  }).format(date)

  return `${dateText} - ${timeText}`
}
